import {Component, HostBinding, HostListener, Input} from '@angular/core';
import {BlockElementIcon} from 'app/entities/blockElements/blockElementIcon';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-element-icon',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementIconComponent extends BlockElementAbstractComponent<BlockElementIcon> {
  @Input() public icon: BlockElementIcon = null;

  @HostBinding('class')
  get classes() {
    const classes = super.classes;

    if (this.blockElement.action) {
      classes.push('ion-activatable');
      classes.push('block-ripple-parent');
    }

    return classes;
  }

  @HostListener('click', ['$event'])
  onClick(e) {
    if (this.blockElement.action) {
      this.actionClick();
    }
  }
}
